<div class="sidenav" *ngIf="!((breakpointObserverService.isMobile | async) && menuService.isMenuOpened)">
  <app-navigation-menu></app-navigation-menu>
</div>
<main class="main">
  <router-outlet></router-outlet>
</main>
